/**
 * This is the JS file for animation functions
 */

// General autoscroll function
$('a[href^="#"]').click(function(e){
	if ($(e.target).hasClass("js-noscroll")==false){
		var idlink = $(this).attr("href");
		$('html, body').animate({
			scrollTop:$(idlink).offset().top - 100
		}, 'slow');
		var $cta = $( ".men__btn-main--wh" );
		var input = $( ".men__last-form-input" );
		if($cta.data('clicked')) {
		  input.focus();
		}
		return false;
	}
});

// Fix body and display mobile menu...
// ...open it
var currentScrollPosition = 0;
$( ".js-burger" ).click(function() {
	if ($( "body" ).hasClass( "menu-is-open" )){
	} else {
		currentScrollPosition = $(document).scrollTop();
	}
  $( "body" ).toggleClass( "no-scroll" );
  $( "html" ).toggleClass( "no-scroll" );
  $( "body" ).toggleClass( "menu-is-open" );
  $('.men__nav').toggleClass('open');


	if ($( "body" ).hasClass( "menu-is-open" )){
		window.setTimeout(function(){

		$(".men__main").animate({ scrollTop: currentScrollPosition - 50 }, 0);
	}, 10);
	} else {
		window.setTimeout(function(){

		$("html,body").animate({ scrollTop: currentScrollPosition }, 0);
	}, 10);
	}

});

if ($('.menu-is-open')){
	$('.men__header_overlay').on('click', function(e){
		$( "body" ).toggleClass( "menu-is-open" );
	  $('.men__nav').toggleClass('open');
		console.log("yessai");
		$( "body" ).toggleClass( "no-scroll" );
	  $( "html" ).toggleClass( "no-scroll" );
	});
}

//
// $('.menu-item-has-children').on('click', function(){
// 	if($(this).find('.sub-menu').hasClass('open_sub'))
// 		$(this).find('.sub-menu').hide().removeClass('open_sub');
// 	else
// 		$(this).find('.sub-menu').show().addClass('open_sub');
//
// });


// ...close it
$( ".men__menu-close" ).click(function() {
	$( ".men__menu-cont--mob" ).addClass( "hidden" );
	// $( "body" ).removeClass( "no-scroll" );
	// $( "html" ).removeClass( "no-scroll" );
	$('.men__nav').removeClass('open');
});

// Change title every N second
$(function() {
	var name = $(".men__welcome-name");
  	var currentHighlight = 0;
  	var sec = 2.3;
		setInterval(function() {
			currentHighlight = (currentHighlight + 1) % name.length;
			name.removeClass('visible-ib').eq(currentHighlight).addClass('visible-ib');
		}, sec * 1000);
});

// Toggles on pricing page
// $( ".men__toggle-cont" ).click(function() {
// 	$( ".men__monthly" ).toggleClass( "is-active" );
// 	$( ".men__annualy" ).toggleClass( "is-active" );
//
// 	// ...if monthly
// 	if ( $( ".men__monthly" ).hasClass( "is-active" ) ) {
// 		$( ".men__annualy" ).removeClass( "is-active" );
// 		$( ".men__toggle" ).removeClass( "is-toggled" );
// 		$( ".men__plan-cost--monthly" ).removeClass( "flipped" );
// 		$( ".men__plan-cost--yearly" ).addClass( "flipped" );
// 	}
//
// 	// ...if yearly
// 	else if ( $( ".men__annualy" ).hasClass( "is-active" ) ) {
// 		$( ".men__monthly" ).removeClass( "is-active" );
// 		$( ".men__toggle" ).addClass( "is-toggled" );
// 		$( ".men__plan-cost--yearly" ).removeClass( "flipped" );
// 		$( ".men__plan-cost--monthly" ).addClass( "flipped" );
// 	}
// });

$( ".js-pricingFlip-switch" ).click(function() {
	$( ".js-monthly" ).toggleClass( "is-active" );
	$( ".js-annualy" ).toggleClass( "is-active" );

	// ...if monthly
	if ( $( ".js-monthly" ).hasClass( "is-active" ) ) {
		$( ".js-annualy" ).removeClass( "is-active" );
		$( ".js-toggle" ).removeClass( "is-toggled" );
		$( ".js-flippable--monthly" ).removeClass( "flipped" );
		$( ".js-flippable--yearly" ).addClass( "flipped" );
	}

	// ...if yearly
	else if ( $( ".js-annualy" ).hasClass( "is-active" ) ) {
		$( ".js-monthly" ).removeClass( "is-active" );
		$( ".js-toggle" ).addClass( "is-toggled" );
		$( ".js-flippable--yearly" ).removeClass( "flipped" );
		$( ".js-flippable--monthly" ).addClass( "flipped" );
	}
});

// Filters for resource page
$( ".men__rsc-nav-links" ).click(function(e) {
	e.preventDefault();

	// set active link on menu
	$( ".men__rsc-nav-links" ).removeClass( "is-active" );
	$( this ).addClass( "is-active" );

	// set term to target and match item with same data-term
	var attr = $(this).attr('data-term');
	var matchEl = $( ".men__rsc-item[data-term='" + attr + "']" );

	// hide all but keep the matching items
	$( ".men__rsc-item" ).removeClass( "visible-ib" );
	$( ".men__rsc-item" ).addClass( "hidden" );
	matchEl.removeClass( "hidden" );
	matchEl.addClass( "visible-ib" );

	// ...if click on all on menu
	if ( $( "#nav__all" ).hasClass( "is-active" ) ) {
		$( ".men__rsc-item" ).removeClass( "visible-ib" );
		$( ".men__rsc-item" ).removeClass( "hidden" );
	}

});

// drop nav bar
// check if page is not pricing, then run
if ($("body").hasClass("page-template-pricing") == false){
	var lastScrollTop = 0;
	var $w = $(window).scroll(function(){

		// deploy nav bar if below 100px but don't show it yet
	  if ( $w.scrollTop() > 100 ) {
		$( ".men__header_nav-wrap" ).addClass( "men__nav--fixed" );
	  } else {
		$( ".men__header_nav-wrap" ).removeClass( "men__nav--fixed" );
	  }

	 // show it below 600px
	  if ( $w.scrollTop() > 600 ) {

			$( ".men__header_nav-wrap" ).addClass( "stick" );
			$('.menu-item--open').removeClass('menu-item--open');
			$('.men__header_menu').removeClass('men__header_menu--haschildopen');

			if (document.body.clientWidth <= 750 ){

				if ($w.scrollTop() < lastScrollTop){
					$( ".men__header_nav-wrap" ).addClass( "stick" );
					$('.menu-item--open').removeClass('menu-item--open');
					$('.men__header_menu').removeClass('men__header_menu--haschildopen');
				} else {
					$( ".men__header_nav-wrap" ).removeClass( "stick" );
				}
			}

			 lastScrollTop = $w.scrollTop();

	  } else {
			$( ".men__header_nav-wrap" ).removeClass( "stick" );
	  }

	});
} else {
	//on page pricing, sticky cells instead of header
	var initialPosition;
	var headertofix;
	margintoadd = $('.men__compare_tr--basic')[0];
	trtocopy = $('.men__compare_tr--advanced')[0];
	trtocopy = $(trtocopy).find("td");
	margintoadd = $(margintoadd).height();

	if ($( document ).width()>1024){
		headertofix = $(".men__compare_tr--plans");
		initialPosition = $(headertofix).offset().top;
	} else {
		headertofix = $(".men__compare_mobileheader");
		initialPosition = $(headertofix).offset().top;
	}
	var $w = $(window).scroll(function(){

		if ( $w.scrollTop() > initialPosition && $w.scrollTop() <= $('.men__faq').offset().top ) {
			$( ".men__compare_table--basic" ).css('margin-top',  $( headertofix ).height() +  margintoadd + "px");
			$( headertofix ).addClass( "men__compare_tr--plans--fixed" );

			for (var i= 0; i < trtocopy.length; i++) {
				var currentcell = $(headertofix).find('td').eq(i);
				var sizetocpy = $(trtocopy).eq(i).outerWidth();
				var paddingtocopy = parseInt($(trtocopy).eq(i).css('padding-left'));
				$(headertofix).find('td').eq(i).css("width", sizetocpy + "px");
			}
		} else {
			$( ".men__compare_table--basic" ).css('margin-top', '0');
			$( headertofix ).removeClass( "men__compare_tr--plans--fixed" );
		}
	});
}

// Scale animation on icons
$(window).scroll(function(){

	// define elements to scale
	var el = $( ".men__tests-cont, .men__job, .men__device" );
	// if exist on page
	if ( el.length ) {

		// get position, height of nav and window height
		var pos = el.offset().top;
		var navheight = $( ".men__nav" ).height() + 100;
		var wheight = $(window).height() - navheight;
		// if window position > (element position - window height) trigger
		if ( $(window).scrollTop() >= (pos - wheight) ) {
			$( ".men__test-face, .men__job-icon, .men__device-icon" ).addClass( "has-scaled" );
		}
	}
}).trigger('scroll');


// Tooltip on pricing page
$( '.men__plan-feat-icon' ).hover(function() {
  $( this ).next( '.men__tooltip' ).toggleClass( 'fadeIn' );
});

// Bubble animation on About page
var a = Math.random() * 10 - 1;
$(".men__ab-bubble").each().css('transform', 'translateY(' + a + 'px) scale(1.1)');

// Accordion on Pricing page
$('.men__faq-block').click(function(e){
	if($(this).hasClass('men__faq-block--opened')){
		$(this).removeClass('men__faq-block--opened');
	} else {
		$(".men__faq-block--opened").removeClass("men__faq-block--opened");
		$(this).toggleClass('men__faq-block--opened');
	}

});

$("svg.men__hintbox-icon").each(function(element){
	$(this).bind("mouseenter",function(){
		$(this).closest(".men__hintbox-parent").find(".men__hintbox-box").addClass("men__hintbox-box--visible");
	});
	$(this).bind("mouseleave",function(){
		$(this).closest(".men__hintbox-parent").find(".men__hintbox-box").removeClass("men__hintbox-box--visible");
	});
});

// allows select to have a differtent colot when a value is selected
$(".men__aod").on("change", "select", function(){
	$(this).addClass('men__select--selected');
});

/*Feature page carousel features*/

if($('.men__feature_glances').length > 0){

	function initFeatureprogress(){
		$('.men__feature_glance--active').find('.men__feature_glance-linkblock').addClass('js-noscroll');
		$('.men__feature_glance--active').removeClass('men__feature_glance--active');
		$(links).eq(currentIndex).addClass('men__feature_glance--active');
		$(links).eq(currentIndex).find('.men__feature_glance-linkblock').removeClass('js-noscroll');
		$('.men__feature_glances-image--active').removeClass('men__feature_glances-image--active');
		$(images).eq(currentIndex).addClass('men__feature_glances-image--active');
		var blockcolor = $(images).eq(currentIndex).data('feature-color');
		$('.men__feature_glances-right').css('background-color' , blockcolor);

		currentIndex++;
		if (currentIndex >= $(links).length) {
			currentIndex = 0;
		}
	}

	var links = $('.js-featureglance-link');
	var images = $('.js-featureglance-img');
	var blocks = $('.js-featureglance-block');
	var currentIndex = 1;
	var glancesinterval = window.setInterval(initFeatureprogress, 5000);

	$(links).click(function(e){
		e.preventDefault();
			$('.men__feature_glance-linkblock').addClass('js-noscroll');

			$('.men__feature_glance--active').removeClass('men__feature_glance--active');
			$('.men__feature_glances-image--active').removeClass('men__feature_glances-image--active');
			clearInterval(glancesinterval);

			currentIndex = $(e.target).closest('.men__feature_glance').data("feature-target");
			$(e.target).closest('.men__feature_glance').addClass('men__feature_glance--active');
			$(e.target).closest('.men__feature_glance-linkblock').removeClass('js-noscroll');
			$(images).eq(currentIndex - 1).addClass('men__feature_glances-image--active');

			var blockcolor = $(images).eq(currentIndex - 1).data('feature-color');
			$('.men__feature_glances-right').css('background-color' , blockcolor);

			if (currentIndex >= $(links).length) {
				currentIndex = 0;
			}

		glancesinterval = window.setInterval(initFeatureprogress, 5000);
	});
}


$('#menu-header > li.menu-item-has-children').click(function(e){

	if ($(e.target).hasClass('menu-item--open') || $(e.target).closest('li').hasClass('menu-item--open')){
		e.preventDefault();
		$('.menu-item--open').removeClass('menu-item--open');
		$('.men__header_menu').removeClass('men__header_menu--haschildopen');
	}

	// if the url is just a # it means it's a menu with children so we prevent the defualt behaviour (addind just # in the url of the current page)
	else if($(e.target).attr('href') == '#') {
		e.preventDefault();
		var header = this;

	// need to set a timeout to zero so that the body click just below doesn"t take priority and prevent menu class to add
		window.setTimeout(function(){
			$(header).addClass('menu-item--open');
			$(header).find('.sub-menu').addClass('menu-item--open');
			$('.men__header_menu').addClass('men__header_menu--haschildopen');
		},0);

	}

});

if($('.menu-item--open')){
	$('body').click(function(){
	$('.menu-item--open').removeClass('menu-item--open');
	$('.men__header_menu').removeClass('men__header_menu--haschildopen');
	//TODO : remove backdrop when scroll ?
	});
}


$('.js-homebutton').on('mouseenter mouseleave', function(){
	$(this).closest('.js-homeblock').toggleClass('men__home_featblock--hover');
});

//subscribe form in footer effect
$(".men__ft-subscribe-wrapper").on("keyup", '.hs_email', function() {
	var inputvalue = $(".men__ft-subscribe-wrapper .hs_email .hs-input").val();
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if(re.test(String(inputvalue).toLowerCase())) {
		$('.men__ft-subscribe-wrapper .hs_submit .hs-button').addClass("hs-button--filled");
	}
	else {
		$('.men__ft-subscribe-wrapper .hs_submit .hs-button').removeClass("hs-button--filled");
	}
});
